import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../../components/PageHeader";
import InputField from "../../../components/InputField";
import { auth } from "../../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../../components/PasswordField";
import axiosInstance from "../../../utils/axiosInstance";
import { addEditExpertise, addEditService, addEditServiceLocations, deleteService, fetchDoctorProfile, fetchDoctorServicesList, registerUser, updateUserDetais } from "../../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";

import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../../components/FullPageLoader";
import ListEmptyText from "../../../components/ListEmptyText";
import MyModal from "../../../components/MyModal";
import Spinner from "../../../components/Spinner";
import TextAreaField from "../../../components/TextAreaField";

export default function ManageServiceLocations() {
  pageTitle("Manage Service Locations");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [doctorDetail, setDoctorDetail] = useState(null);

  const [editServiceLocationData, setEditServiceLocationData] = useState();
  const [deleteServiceLocationId, setDeleteServiceLocationId] = useState("");
  const [editServiceLocationModalOpen, setEditServiceLocationModalOpen] = useState(false);
  const [deleteServiceLocationModalOpen, setDeleteServiceLocationModalOpen] = useState(false);
  const [addServiceLocationModalOpen, setAddServiceLocationModalOpen] = useState(false);
  const [addServiceLocationData, setAddServiceLocationData] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditPress = (serviceLocationData) => {
    setEditServiceLocationData(serviceLocationData);
    setEditServiceLocationModalOpen(true);
  };

  const handleDeletePress = (serviceLocationData) => {
    setDeleteServiceLocationId(serviceLocationData.id);
    setDeleteServiceLocationModalOpen(true);
  };

  const handleOpenAServiceLocationModal = () => {
    setAddServiceLocationModalOpen(true);
    setAddServiceLocationData({ hospital_title: "", hospital_location: "" });
  };

  const closeAddModal = () => setAddServiceLocationModalOpen(false);
  const closeEditModal = () => setEditServiceLocationModalOpen(false);
  const closeDeleteModal = () => setDeleteServiceLocationModalOpen(false);

  const onAddSubmit = () => {
    if (!editServiceLocationData?.title === "") {
      toast.error("Please provide Expertise title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditServiceLocations, {
        doctor_id: doctorId,
        hospital_title: addServiceLocationData?.hospital_title,
        hospital_address: addServiceLocationData?.hospital_address,
        type: 1,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Service Location added successfully.");
          setAddServiceLocationData("");
          setAddServiceLocationModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onEditSubmit = () => {
    if (editServiceLocationData?.hospital_title === "" || editServiceLocationData?.hospital_location == "") {
      toast.error("Please fill all fields");
      return;
    }

    setSubmitting(true);
    axiosInstance
      .post(addEditServiceLocations, {
        doctor_id: doctorId,
        serviceLocation_id: editServiceLocationData?.id,
        hospital_title: editServiceLocationData?.hospital_title,
        hospital_address: editServiceLocationData?.hospital_address,
        type: 2,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Service Location updated successfully.");
          setEditServiceLocationData("");
          setEditServiceLocationModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onDeleteClick = () => {
    setSubmitting(true);
    axiosInstance
      .post(addEditServiceLocations, {
        doctor_id: doctorId,
        serviceLocation_id: deleteServiceLocationId,
        type: 3,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Service Location deleted successfully.");
          setDeleteServiceLocationId("");
          setDeleteServiceLocationModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader
              canBack
              title="Service Locations"
              trailing={
                <button type="button" className="bg-success-surface px-3 rounded" onClick={handleOpenAServiceLocationModal}>
                  Add New
                </button>
              }
            />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark fw-medium">Add Hospitals Where You Visit (Optional)</strong>
                  <p className="text-grey2 fs-normal">This helps patient to take a visit to you directly on those locations.</p>
                </div>
              </div>
              <div className="col-md-6">
                {!loading && doctorDetail && doctorDetail?.service_locations.length === 0 && <ListEmptyText text={"No Service Location added yet."} />}
                {!loading && doctorDetail && doctorDetail?.service_locations.length > 0 && (
                  <div className="w-full">
                    {doctorDetail?.service_locations.map((serviceLocation) => (
                      <div key={serviceLocation.id} className="d-flex justify-content-between bg-grey2 mb-2 rounded">
                        <div className="d-flex  flex-column px-3 py-2  ">
                          <strong className="fs-normal text-dark fw-bold">{serviceLocation.hospital_title}</strong>
                          <span className="fs-md text-grey2">{serviceLocation.hospital_address}</span>
                        </div>

                        <div className="d-flex gap-2">
                          <button type="button" className="bg-warning-surface px-3 rounded" onClick={() => handleEditPress(serviceLocation)}>
                            Edit
                          </button>
                          <button type="button" className="bg-danger-surface px-3 rounded" onClick={() => handleDeletePress(serviceLocation)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>
      )}
      {/* Edit Expertise Modal */}
      <MyModal isOpen={editServiceLocationModalOpen} modalTitle={"Edit Service Location"} onClose={closeEditModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField label={"Hospital Name"} value={editServiceLocationData?.hospital_title} onChange={(e) => setEditServiceLocationData({ ...editServiceLocationData, hospital_title: e.target.value })} />
          <TextAreaField label={"Hospital Address"} value={editServiceLocationData?.hospital_address} onChange={(e) => setEditServiceLocationData({ ...editServiceLocationData, hospital_address: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onEditSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Add Expertise Modal */}
      <MyModal isOpen={addServiceLocationModalOpen} modalTitle={"Add Service Location"} onClose={closeAddModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField label={"Add Service Location"} value={addServiceLocationData?.hospital_title} onChange={(e) => setAddServiceLocationData({ ...addServiceLocationData, hospital_title: e.target.value })} />
          <TextAreaField label={"Hospital Address"} value={addServiceLocationData?.hospital_address} onChange={(e) => setAddServiceLocationData({ ...addServiceLocationData, hospital_address: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onAddSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Delete Modal */}
      <MyModal isOpen={deleteServiceLocationModalOpen} modalTitle={"Delete Service Location"} onClose={closeDeleteModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <SecondaryButton title="Delete" onClick={onDeleteClick} loading={submitting} />
        </div>
      </MyModal>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
